import { api } from '@services';

import Resource, { IResource, IResourceApiModel } from '@models/Resource.model';

interface IRequest {
  equipmentId: string;
}

const getEquipmentResources = async ({
  equipmentId,
}: IRequest): Promise<IResource[]> => {
  const { data: resources } = await api.get<IResourceApiModel[]>(
    `/equipments/${equipmentId}/resources`,
  );

  return Resource.arrayFromApiModel(resources);
};

export { getEquipmentResources };
